import { useMemo } from "react";
import { bool, number, object } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { BufferTooltipContent } from "./components";

export const BreakdownCombinedWorkloadBufferTooltip = observer(({
  element,
  cleanValue,
  isMax
}) => {
  const structure = useEstimateStructure();
  const { maxValuesAsBuffer } = structure.settings;
  
  const displayTwoValues = element.displayTotalTwoValues;
  
  const valueKey = useMemo(() => {
    if(maxValuesAsBuffer)
      return MinAvgMaxKeys.AVG;
    if(isMax)
      return MinAvgMaxKeys.MAX;
    
    return displayTwoValues ? MinAvgMaxKeys.MIN : MinAvgMaxKeys.AVG;
  }, [isMax, displayTwoValues, maxValuesAsBuffer])
  
  const bufferedValues = element.getAllBufferedValues(valueKey);
  
  return <BufferTooltipContent
    cleanValue={cleanValue}
    bufferedValues={bufferedValues}
  />
});

BreakdownCombinedWorkloadBufferTooltip.propTypes = {
  element: object.isRequired,
  cleanValue: number.isRequired,
  isMax: bool,
}